import { PartnerService } from "~/services/public/PartnerService"

export const state = (): Partner => ({
  stores: null
})

export const GET_STORES = "getStores"

export const getters = {
  [GET_STORES]: (state: Partner): Record<number, Store>[] | null => state.stores,
}

export const _SET_STORES = "setStores"

export const mutations = {
  [_SET_STORES](state: Partner, stores:  Record<number, Store>) {
    state.stores = stores
  }
}

export const LOAD_STORES = "loadStores"
export const SET_STORES = "setStores"
export const GET_STORE = "getStore"

export const actions = {
  async [LOAD_STORES]({ state, commit }, {$axios, $config, ident, locale}) {
    if (ident) {
      const partnerService = new PartnerService($axios, $config)
      const response = await partnerService.getStores(ident, locale)

      if (response && response.data && response.data.length > 0) {
        const stores = Object.fromEntries(
          response.data.map((store: Store) => [store.affiliate_store_id, store])
        ) as Record<number, Store>
        commit(_SET_STORES, stores)
      }
    }
  },
  [SET_STORES]({ commit }, stores: Record<number, Store>) {
    commit(_SET_STORES, stores)
  },
  [GET_STORE]({ state }, affiliateStoreId: number) {
    return state.stores[affiliateStoreId]
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
